// User-facing copy: common. Moved from the web app (components/ui.tsx, components/UpdateBanner.tsx, components/Wordmark.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/ui.tsx */
export const ui = {
    back: "Back",
    working: "Working…",
    yesDoIt: "Yes, do it",
    cancel: "Cancel",
    loading: "Loading",
    close: "Close",
};
/** components/UpdateBanner.tsx */
export const updateBanner = {
    updatedTapToRefresh: "Updated, tap to refresh",
};
/** components/Wordmark.tsx */
export const wordmark = {
    pagemates: "Pagemates",
};
//# sourceMappingURL=common.js.map